import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
import Select from "react-select";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import InvoiceModal from "../../../components/Modal/InvoiceModal";
import ArModal from "../../../components/Modal/ArModal";
import FormAction from "../../../components/Actions/FormAction";
import FileModal from "../../../components/Modal/FileModal";

// Model
import { rcvMasterModel } from "../../../../model/Account/RcvMasterModel";
import { rcvDetailModel } from "../../../../model/Account/RcvDetailModel";

// Utils
import {
    getData,
    getDataWithComp,
    getDocType,
    getAlert,
    formatCurrency,
    parseCurrency,
    insertData,
    updateData,
    deleteData,
} from "../../../../utils/SamuiUtils";

import {
    formatThaiDateUi,
    formatStringDateToDate,
    formatDateOnChange,
    getCreateDateTime,
    setCreateDateTime,
    formatThaiDateUiToDate,
} from "../../../../utils/DateUtils";

function Form({ callInitialize, mode, name, maxRcvNo, getReport, masterList }) {
    const [formMasterList, setFormMasterList] = useState([rcvMasterModel()]);
    const [formDetailList, setFormDetailList] = useState([]);
    const [arDataList, setArDataList] = useState([]);
    const [invDataList, setInvDataList] = useState([]);
    const [itemDataList, setItemDataList] = useState([]);

    // Calculation
    const [totalPrice, setTotalPrice] = useState(0);
    const [receiptDiscount, setReceiptDiscount] = useState(0);
    const [subFinal, setSubFinal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [outstandingBalance, setOutstandingBalance] = useState(0);
    const [isVatChecked, setIsVatChecked] = useState(true);
    const [vatAmount, setVatAmount] = useState(0);
    const [totalWT, setTotalWT] = useState(0);
    const [inputValueTotalWT, setInputValueTotalWT] = useState("0.00");
    const [disTotal, setDisTotal] = useState(0);
    const [inputValuedisTotal, setInputValuedisTotal] = useState("0.00");

    // Tabs
    const [activeTab, setActiveTab] = useState("summary");

    // Status
    const [statusName, setStatusName] = useState("");
    const [statusColour, setStatusColour] = useState("");

    // Payment Status (Installment)
    const [paymentStatus, setPaymentStatus] = useState("oneTime");
    const [installmentCount, setInstallmentCount] = useState(1);

    // Payment Method
    const [paymentType, setPaymentType] = useState({
        cash: true,
        transfer: false,
        cheque: false,
    });
    const [chequeBank, setChequeBank] = useState("");
    const [chequeNo, setChequeNo] = useState("");
    const [chequeDate, setChequeDate] = useState("");
    const [transferDate, setTransferDate] = useState("");

    // Modals
    const [showInvModal, setShowInvModal] = useState(false);
    const [showArModal, setShowArModal] = useState(false);
    const [showModalDatePicker, setShowModalDatePicker] = useState(false);
    const [selectedDateIndex, setSelectedDateIndex] = useState(null);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        try {
            const arList = await getDataWithComp("Tb_Set_AR", "ORDER BY AR_Code ASC");
            if (arList) setArDataList(arList);

            const invList = await getDataWithComp("API_0701_SO_H", "AND Doc_Status_Paid != '3' AND  Doc_Status ='2' ORDER BY Doc_No DESC");
            if (invList) setInvDataList(invList);

            if (mode === "U") {
                await getModelByNo(arList);
            }
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const getModelByNo = async (arList) => {
        try {
            const findMaster = await getDataWithComp(
                "RCV_H",
                `AND Rcv_No = '${maxRcvNo}'`
            );
            const fromDatabase = findMaster[0];

            if (!fromDatabase) throw new Error("Document not found");

            const ar = arList.find((a) => a.AR_Id === fromDatabase.AR_Id);

            setFormMasterList([
                {
                    ...rcvMasterModel(),
                    rcvId: fromDatabase.Rcv_Id,
                    rcvNo: fromDatabase.Rcv_No,
                    rcvDate: formatThaiDateUi(fromDatabase.Rcv_Date),
                    rcvStatus: fromDatabase.Rcv_Status,
                    rcvType: fromDatabase.Rcv_Type,
                    arID: fromDatabase.AR_Id,
                    arCode: fromDatabase.AR_Code,
                    arName: ar ? ar.AR_Name : "",
                    arAdd1: ar ? ar.AR_Add1 : "",
                    arAdd2: ar ? ar.AR_Add2 : "",
                    arAdd3: ar ? ar.AR_Add3 : "",
                    arProvince: ar ? ar.AR_Province : "",
                    arZipcode: ar ? ar.AR_Zipcode : "",
                    arTaxNo: ar ? ar.AR_TaxNo : "",
                    docRemark1: fromDatabase.Doc_Remark1,
                    docRemark2: fromDatabase.Doc_Remark2,
                    pay_trans_type: fromDatabase.Pay_Trans_Type,
                    pay_cheque_bank: fromDatabase.Pay_Cheque_Bank,
                    pay_cheque_no: fromDatabase.Pay_Cheque_No,
                    pay_cheque_date: fromDatabase.Pay_Cheque_Date,
                    rcv_cash: fromDatabase.Rcv_Cash,
                    createdDate: setCreateDateTime(fromDatabase.Created_Date),
                    createdByName: fromDatabase.Created_By_Name,
                    updateDate: setCreateDateTime(fromDatabase.Update_Date),
                    updateByName: fromDatabase.Update_By_Name,
                    amountRcv: formatCurrency(fromDatabase.Total_Pay_Per),
                    refDoc: fromDatabase.Ref_Doc || "",
                    // refDocDate: fromDatabase.Ref_DocDate ? formatThaiDateUi(fromDatabase.Ref_DocDate) : "",
                },
            ]);

            setPaymentType({
                cash: fromDatabase.Pay_Trans_Type === 0,
                transfer: fromDatabase.Pay_Trans_Type === 1,
                cheque: fromDatabase.Pay_Trans_Type === 2,
            });
            if (fromDatabase.Pay_Trans_Type === 2) {
                setChequeBank(fromDatabase.Pay_Cheque_Bank);
                setChequeNo(fromDatabase.Pay_Cheque_No);
                setChequeDate(
                    fromDatabase.Pay_Cheque_Date
                        ? moment(fromDatabase.Pay_Cheque_Date).format("YYYY-MM-DD")
                        : ""
                );
            }

            const findDetail = await getDataWithComp(
                "RCV_D",
                `AND Rcv_Id = ${fromDatabase.Rcv_Id} ORDER BY Line ASC`
            );
            if (findDetail) {
                const details = findDetail.map((item, index) => ({
                    ...rcvDetailModel(index + 1),
                    rcvDId: item.Rcv_D_Id,
                    rcvId: item.Rcv_Id,
                    invId: item.INV_Id,
                    line: item.Line,
                    itemDesc: item.Item_Desc,
                    itemPrice: formatCurrency(item.Item_Price),
                    itemDiscount: formatCurrency(item.Item_Discount),
                    itemDisType: item.Item_DisType,
                    itemTotal: item.Item_Total,
                    itemStatus: item.Item_Status,
                    dsSeq: item.DS_SEQ,
                }));
                setFormDetailList(details);
            }

            // Calculate totals
            const total = fromDatabase.Total_Pay_Per; // Simplified for now
            setGrandTotal(total);
            setTotalPrice(total);
            setOutstandingBalance(0); // Assuming paid
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleChangeMasterList = (index, field, value) => {
        const updatedList = [...formMasterList];
        updatedList[index][field] = value;
        setFormMasterList(updatedList);
    };

    const handleChangeDateMasterList = (value, name, index) => {
        const newValue =
            value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
        const updatedList = [...formMasterList];
        updatedList[index][name] = formatDateOnChange(newValue);
        setFormMasterList(updatedList);
    };

    const handleArShow = () => setShowArModal(true);
    const handleArClose = () => setShowArModal(false);
    const onRowSelectAr = (ar) => {
        const newMasterList = [...formMasterList];
        newMasterList[0].arID = ar.AR_Id;
        newMasterList[0].arCode = ar.AR_Code;
        newMasterList[0].arName = ar.AR_Name;
        newMasterList[0].arAdd1 = ar.AR_Add1;
        newMasterList[0].arAdd2 = ar.AR_Add2;
        newMasterList[0].arAdd3 = ar.AR_Add3;
        newMasterList[0].arProvince = ar.AR_Province;
        newMasterList[0].arZipcode = ar.AR_Zipcode;
        newMasterList[0].arTaxNo = ar.AR_TaxNo;
        setFormMasterList(newMasterList);
        setShowArModal(false);
    };

    const handleInvShow = () => setShowInvModal(true);
    const handleInvClose = () => setShowInvModal(false);
    const onRowSelectInv = async (selectedInvoices) => {
        if (!selectedInvoices || selectedInvoices.length === 0) return;

        // 1. Clear old details
        setFormDetailList([]);

        // 2. Update Master with Ref Doc and Customer Info (Use the first invoice)
        const firstInv = selectedInvoices[0];
        const newMaster = [...formMasterList];

        // Show only the first selected INV in RefDoc
        newMaster[0].refDoc = firstInv.Doc_No;
        newMaster[0].refDocDate = formatThaiDateUi(firstInv.Doc_Date);

        // Always auto-populate customer from the selected invoice
        newMaster[0].arID = firstInv.AR_ID;
        newMaster[0].arCode = firstInv.AR_Code;
        newMaster[0].arName = firstInv.AR_Name;
        newMaster[0].arAdd1 = firstInv.AR_Add1;
        newMaster[0].arAdd2 = firstInv.AR_Add2;
        newMaster[0].arAdd3 = firstInv.AR_Add3;
        newMaster[0].arProvince = firstInv.AR_Province;
        newMaster[0].arZipcode = firstInv.AR_Zipcode;
        newMaster[0].arTaxNo = firstInv.AR_TaxNo;

        setFormMasterList(newMaster);

        // 3. Add Summary Lines for EACH selected invoice
        const newDetails = selectedInvoices.map((inv, index) => ({
            ...rcvDetailModel(index + 1),
            invId: inv.Doc_ID,
            itemDesc: `ค่าสินค้า ${inv.Doc_No}`,
            itemPrice: formatCurrency(inv.Pay_Total),
            itemTotal: inv.Pay_Total,
            itemStatus: 1,
        }));

        setFormDetailList(newDetails);

        setShowInvModal(false);
    };

    const handleAddManualItem = () => {
        const newDetail = {
            ...rcvDetailModel(formDetailList.length + 1),
            itemDesc: "รายการเพิ่มเอง",
            itemPrice: "0.00",
            itemTotal: 0,
            itemStatus: 1,
        };
        setFormDetailList([...formDetailList, newDetail]);
    };

    const handleDetailChange = (index, field, value) => {
        const newDetailList = [...formDetailList];
        newDetailList[index][field] = value;

        if (field === "itemPrice" || field === "itemDiscount") {
            const price = parseCurrency(newDetailList[index].itemPrice);
            const discount = parseCurrency(newDetailList[index].itemDiscount);
            newDetailList[index].itemTotal = price - discount;
        }

        setFormDetailList(newDetailList);
    };

    const handleRemoveDetail = (index) => {
        const newList = formDetailList.filter((_, i) => i !== index);
        setFormDetailList(newList);
    };

    // Totals Calculation
    useEffect(() => {
        const total = formDetailList.reduce(
            (sum, item) => sum + (parseFloat(item.itemTotal) || 0),
            0
        );
        setGrandTotal(total);

        // Update amountRcv in master list for display
        const updatedMaster = [...formMasterList];
        if (updatedMaster.length > 0) {
            updatedMaster[0].amountRcv = formatCurrency(total);
            setFormMasterList(updatedMaster);
        }

        // Outstanding logic (simplified)
        if (formMasterList[0]?.rcvStatus === 1) {
            setOutstandingBalance(total);
        } else {
            setOutstandingBalance(0);
        }

    }, [formDetailList]);

    const handleSave = async () => {
        // Save Logic (Similar to previous implementation but adapted)
        try {
            // Validation
            if (!formMasterList[0].arID) {
                getAlert("FAILED", "กรุณาเลือกลูกค้า");
                return;
            }

            // Generate RcvNo if Insert
            let rcvNo = formMasterList[0].rcvNo;
            if (mode === "I") {
                const prefix = "RCV" + moment().format("YYMM");
                const maxRes = await getDataWithComp("RCV_H", `AND Rcv_No LIKE '${prefix}%' ORDER BY Rcv_No DESC`);
                let nextSeq = "0001";
                if (maxRes && maxRes.length > 0) {
                    const lastNo = maxRes[0].Rcv_No;
                    const lastSeq = parseInt(lastNo.substr(lastNo.length - 4));
                    nextSeq = String(lastSeq + 1).padStart(4, "0");
                }
                rcvNo = prefix + nextSeq;
            }

            const masterData = {
                Rcv_No: rcvNo,
                Rcv_Date: formatThaiDateUiToDate(formMasterList[0].rcvDate)?.split(" ")[0],
                Rcv_Status: 1, // Normal
                Rcv_Type: formMasterList[0].rcvType,
                AR_Id: formMasterList[0].arID,
                AR_Code: formMasterList[0].arCode,
                Total_Pay_Per: grandTotal,
                Pay_Trans_Type: paymentType.cash ? 0 : paymentType.transfer ? 1 : 2,
                Pay_Cheque_Bank: paymentType.cheque ? chequeBank : null,
                Pay_Cheque_No: paymentType.cheque ? chequeNo : null,
                Pay_Cheque_Date: paymentType.cheque && chequeDate ? chequeDate : null,
                Rcv_Cash: (paymentType.cash || paymentType.transfer) ? "CASH" : "CHEQUE",
                Comp_Id: window.localStorage.getItem("company"),
                Created_By_Name: window.localStorage.getItem("name"),
                Ref_Doc: formMasterList[0].refDoc,
                Ref_DocDate: formMasterList[0].refDocDate ? moment(formMasterList[0].refDocDate, "DD/MM/YYYY").format("YYYY-MM-DD") : null,
                Doc_Remark1: formMasterList[0].docRemark1,
                Doc_Remark2: formMasterList[0].docRemark2,
            };

            if (mode === "I") {
                const res = await insertData("RCV_H", Object.keys(masterData).join(", "), Object.values(masterData));
                if (res.status === "OK") {
                    const inserted = await getDataWithComp("RCV_H", `AND Rcv_No = '${rcvNo}'`);
                    const rcvId = inserted[0].Rcv_Id;

                    for (const [index, item] of formDetailList.entries()) {
                        const detailData = {
                            Rcv_Id: rcvId,
                            INV_Id: item.invId,
                            Line: index + 1,
                            Item_Desc: item.itemDesc,
                            Item_Price: parseCurrency(item.itemPrice),
                            Item_Total: item.itemTotal,
                            Item_Status: 1,
                            Comp_Id: window.localStorage.getItem("company")
                        };
                        const resDetail = await insertData("RCV_D", Object.keys(detailData).join(", "), Object.values(detailData));
                        if (resDetail.status !== "OK") {
                            getAlert("FAILED", "บันทึกรายการไม่สำเร็จ: " + resDetail.message);
                            return;
                        }
                    }
                    getAlert("OK", "บันทึกสำเร็จ");
                    callInitialize();
                } else {
                    getAlert("FAILED", "บันทึกไม่สำเร็จ: " + res.message);
                }
            } else {
                // Update
                await updateData("RCV_H", masterData, `Rcv_No = '${rcvNo}'`);
                const rcvId = formMasterList[0].rcvId;
                await deleteData("RCV_D", `WHERE Rcv_Id = ${rcvId}`);
                for (const [index, item] of formDetailList.entries()) {
                    const detailData = {
                        Rcv_Id: rcvId,
                        INV_Id: item.invId,
                        Line: index + 1,
                        Item_Desc: item.itemDesc,
                        Item_Price: parseCurrency(item.itemPrice),
                        Item_Total: item.itemTotal,
                        Item_Status: 1,
                        Comp_Id: window.localStorage.getItem("company")
                    };
                    const resDetail = await insertData("RCV_D", Object.keys(detailData).join(", "), Object.values(detailData));
                    if (resDetail.status !== "OK") {
                        getAlert("FAILED", "บันทึกรายการไม่สำเร็จ: " + resDetail.message);
                        return;
                    }
                }
                getAlert("OK", "บันทึกสำเร็จ");
                callInitialize();
            }

        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const togglePaymentMethod = (method) => {
        setPaymentType({
            cash: method === "cash",
            transfer: method === "transfer",
            cheque: method === "cheque",
        });
    };

    const PAYMENT_METHODS = {
        transfer: "โอนเงิน",
        cash: "เงินสด",
        cheque: "เช็ค",
    };

    const openModalDatePicker = (index) => {
        setSelectedDateIndex(index);
        setShowModalDatePicker(true);
    };

    const handlePrint = () => {
        if (getReport) {
            const isCashOrTransfer = paymentType.cash || paymentType.transfer;
            const reportName = isCashOrTransfer ? "RCV_CASH" : "RCV_CHEQUE";
            getReport(reportName, formMasterList[0].rcvNo);
        }
    };

    return (
        <>
            <Breadcrumbs
                page={maxRcvNo}
                isShowStatus={mode === "U"}
                statusName={statusName}
                statusColour={statusColour}
                onHandleClick={handlePrint}
                items={[
                    { name: "งานบัญชี", url: "/account" },
                    { name: name, url: "/receipt-voucher" },
                    { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
                ]}
            />
            <div
                className="hidden-scrollbar"
                style={{ maxHeight: "auto", overflowY: "auto" }}
            >
                {/* Header Section */}
                <div className="row mt-1">
                    <div className="col-3">
                        <div className="d-flex align-items-center">
                            <label>วันที่เอกสาร</label>
                            <Datetime
                                className="input-spacing-input-date"
                                name="rcvDate"
                                value={formMasterList[0]?.rcvDate || null}
                                onChange={(date) =>
                                    handleChangeDateMasterList(date, "rcvDate", 0)
                                }
                                dateFormat="DD-MM-YYYY"
                                timeFormat={false}
                                inputProps={{ readOnly: true, disabled: mode === "U" }}
                            />
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="d-flex align-items-center">
                            <label>ลูกค้า</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control input-spacing"
                                    value={
                                        (formMasterList[0]?.arCode || "") +
                                        " " +
                                        (formMasterList[0]?.arName || "")
                                    }
                                    disabled={true}
                                />
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={handleArShow}
                                    disabled={mode === "U"}
                                >
                                    <i className="fas fa-search"></i>
                                </button>
                            </div>
                        </div>
                        <ArModal
                            showArModal={showArModal}
                            handleArClose={handleArClose}
                            arDataList={arDataList}
                            onRowSelectAr={onRowSelectAr}
                        />
                    </div>
                    <div className="col-2" />
                    <div className="col-3 text-right">
                        <div className="d-flex align-items-center">
                            <label>วันที่สร้างเอกสาร</label>
                            <input
                                type="text"
                                className="form-control input-spacing"
                                value={formMasterList[0]?.createdDate || ""}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>

                {/* Info Row 1 */}
                <div className="row mt-1">
                    <div className="col-3">
                        <div className="d-flex align-items-center">
                            <label>ประเภทการรับ</label>
                            <select
                                className="form-select form-control input-spacing"
                                value={formMasterList[0]?.rcvType}
                                onChange={(e) => {
                                    const newList = [...formMasterList];
                                    newList[0].rcvType = parseInt(e.target.value);
                                    setFormMasterList(newList);
                                    setFormDetailList([]);
                                }}
                                disabled={mode === "U"}
                            >
                                <option value="1">รับจาก Invoice</option>
                                <option value="2">รับเฉพาะรายการ</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="d-flex align-items-center">
                            <label>ที่อยู่</label>
                            <input
                                type="text"
                                className="form-control input-spacing"
                                value={formMasterList[0]?.arAdd1 || ""}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="col-2" />
                    <div className="col-3 text-right">
                        <div className="d-flex align-items-center">
                            <label>ผู้สร้างเอกสาร</label>
                            <input
                                type="text"
                                className="form-control input-spacing"
                                value={formMasterList[0]?.createdByName || ""}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>

                {/* Info Row 2 */}
                <div className="row mt-1">
                    <div className="col-3">
                        <div className="d-flex align-items-center">
                            <label>อ้างอิงเอกสาร</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control input-spacing"
                                    value={formMasterList[0]?.refDoc || ""}
                                    disabled={true}
                                />
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={handleInvShow}
                                    hidden={formMasterList[0]?.rcvType === 1 ? false : true}
                                    disabled={mode === "U"}
                                >
                                    <i className="fas fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="d-flex align-items-center">
                            <label></label>
                            <input
                                type="text"
                                className="form-control input-spacing"
                                value={
                                    (formMasterList[0]?.arAdd2 || "") +
                                    " " +
                                    (formMasterList[0]?.arAdd3 || "")
                                }
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="col-2" />
                    <div className="col-3 text-right">
                        <div className="d-flex align-items-center">
                            <label>วันที่แก้ไขล่าสุด</label>
                            <input
                                type="text"
                                className="form-control input-spacing"
                                value={formMasterList[0]?.updateDate || ""}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>

                {/* Tabs Section */}
                <div className="row mt-2">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <ul className="nav nav-tabs">
                                    <li className="nav-item">
                                        <button
                                            style={{ cursor: "pointer", color: "#EF6C00" }}
                                            className={`nav-link ${activeTab === "summary" ? "active" : ""
                                                }`}
                                            onClick={() => handleTabChange("summary")}
                                        >
                                            ยอดรวม
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            style={{ cursor: "pointer", color: "#EF6C00" }}
                                            className={`nav-link ${activeTab === "details" ? "active" : ""
                                                }`}
                                            onClick={() => handleTabChange("details")}
                                        >
                                            รายละเอียดสินค้า
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            {/* Summary Tab Content */}
                            {activeTab === "summary" ? (
                                <div className="card-body">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-5">
                                                        <div>
                                                            <h4 className="card-title">ยอดท้ายบิล</h4>
                                                            <div className="row mt-3">
                                                                <div className="col-12">
                                                                    {/* Payment Status */}
                                                                    <div className="row">
                                                                        <div className="col-3">
                                                                            <label>สถานะรับ</label>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="radio-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    checked={paymentStatus === "oneTime"}
                                                                                    onChange={() =>
                                                                                        setPaymentStatus("oneTime")
                                                                                    }
                                                                                />
                                                                                <label className="form-check-label">
                                                                                    รับครั้งเดียว
                                                                                </label>
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    checked={
                                                                                        paymentStatus === "installment"
                                                                                    }
                                                                                    onChange={() =>
                                                                                        setPaymentStatus("installment")
                                                                                    }
                                                                                />
                                                                                <label className="form-check-label">
                                                                                    รับเป็นงวด
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            {paymentStatus === "installment" && (
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control text-end input-spacing"
                                                                                    style={{ width: "100px" }}
                                                                                    value={installmentCount}
                                                                                    onChange={(e) =>
                                                                                        setInstallmentCount(e.target.value)
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* Total Price */}
                                                                    <div className="row mt-4">
                                                                        <div className="col-3">
                                                                            <label>รวมราคา</label>
                                                                        </div>
                                                                        <div className="col-9">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-end input-spacing"
                                                                                style={{ width: "100px" }}
                                                                                value={formatCurrency(totalPrice || 0)}
                                                                                disabled={true}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Grand Total */}
                                                                    <div className="row mt-4">
                                                                        <div className="col-3">
                                                                            <label>
                                                                                <h5>รวมยอด</h5>
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-end input-spacing"
                                                                                style={{
                                                                                    width: "100px",
                                                                                    color: "red",
                                                                                    fontWeight: "bold",
                                                                                    fontSize: "18px",
                                                                                }}
                                                                                value={formatCurrency(grandTotal || 0)}
                                                                                disabled={true}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Payment Methods */}
                                                                    <div className="row mt-3">
                                                                        <div className="col-3">
                                                                            <label>
                                                                                <h5>ช่องทางการรับ</h5>
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-9 d-flex justify-content-start align-items-center flex-wrap gap-2">
                                                                            {Object.keys(PAYMENT_METHODS).map(
                                                                                (method) => (
                                                                                    <button
                                                                                        key={method}
                                                                                        onClick={() =>
                                                                                            togglePaymentMethod(method)
                                                                                        }
                                                                                        className="btn"
                                                                                        style={{
                                                                                            minWidth: "100px",
                                                                                            borderRadius: "8px",
                                                                                            border: "1px solid #ccc",
                                                                                            backgroundColor: paymentType[
                                                                                                method
                                                                                            ]
                                                                                                ? "#EF6C00"
                                                                                                : "white",
                                                                                            color: paymentType[method]
                                                                                                ? "white"
                                                                                                : "black",
                                                                                            fontWeight: paymentType[method]
                                                                                                ? "bold"
                                                                                                : "normal",
                                                                                        }}
                                                                                    >
                                                                                        {PAYMENT_METHODS[method]}
                                                                                    </button>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* Cheque Details */}
                                                                    {paymentType.cheque && (
                                                                        <div className="row mt-3 p-2 bg-light">
                                                                            <div className="col-12">
                                                                                <div className="d-flex gap-2">
                                                                                    <input type="text" className="form-control" placeholder="ธนาคาร" value={chequeBank} onChange={(e) => setChequeBank(e.target.value)} />
                                                                                    <input type="text" className="form-control" placeholder="เลขที่เช็ค" value={chequeNo} onChange={(e) => setChequeNo(e.target.value)} />
                                                                                    <input type="date" className="form-control" value={chequeDate} onChange={(e) => setChequeDate(e.target.value)} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Table Pay (Installments) */}
                                                    <div className="col-7">
                                                        <div className="card">
                                                            <div className="card-header">
                                                                <h4 className="card-title">ตารางรับเงิน</h4>
                                                            </div>
                                                            <div className="card-body">
                                                                <div
                                                                    className="table-responsive"
                                                                    style={{ maxHeight: "300px", overflowY: "auto" }}
                                                                >
                                                                    <table className="table table-striped table-hover">
                                                                        <thead className="thead-dark">
                                                                            <tr>
                                                                                <th className="text-center">#</th>
                                                                                <th className="text-center">วันที่รับ</th>
                                                                                <th className="text-center">จำนวนเงิน</th>
                                                                                <th className="text-center">หมายเหตุ</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {formMasterList.map((item, index) => (
                                                                                <tr key={index}>
                                                                                    <td className="text-center">
                                                                                        {index + 1}
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control text-center"
                                                                                            value={item.rcvDate || ""}
                                                                                            readOnly
                                                                                        />
                                                                                    </td>
                                                                                    <td className="text-end">
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control text-end"
                                                                                            value={item.amountRcv || formatCurrency(grandTotal)}
                                                                                            onChange={(e) => handleChangeMasterList(index, "amountRcv", e.target.value)}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control"
                                                                                            value={item.docRemark1 || ""}
                                                                                            onChange={(e) => handleChangeMasterList(index, "docRemark1", e.target.value)}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                /* Details Tab Content */
                                <div className="card-body">
                                    <div className="text-end mb-2">
                                        {formMasterList[0].rcvType === 1 ? (
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleInvShow}
                                            >
                                                <i className="fas fa-plus"></i> เพิ่มรายการจาก Invoice
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleAddManualItem}
                                            >
                                                <i className="fas fa-plus"></i> เพิ่มรายการ
                                            </button>
                                        )}
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th className="text-center" style={{ width: "5%" }}>#</th>
                                                    <th className="text-center" style={{ width: "40%" }}>รายละเอียด</th>
                                                    <th className="text-center" style={{ width: "15%" }}>ราคาต่อหน่วย</th>
                                                    <th className="text-center" style={{ width: "15%" }}>ส่วนลด</th>
                                                    <th className="text-center" style={{ width: "15%" }}>รวมเงิน</th>
                                                    <th className="text-center" style={{ width: "10%" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formDetailList.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={item.itemDesc}
                                                                onChange={(e) =>
                                                                    handleDetailChange(
                                                                        index,
                                                                        "itemDesc",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                readOnly={formMasterList[0].rcvType === 1}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control text-end"
                                                                value={item.itemPrice}
                                                                onChange={(e) =>
                                                                    handleDetailChange(
                                                                        index,
                                                                        "itemPrice",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                readOnly={formMasterList[0].rcvType === 1}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control text-end"
                                                                value={item.itemDiscount}
                                                                onChange={(e) =>
                                                                    handleDetailChange(
                                                                        index,
                                                                        "itemDiscount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                readOnly={formMasterList[0].rcvType === 1}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control text-end"
                                                                value={formatCurrency(item.itemTotal)}
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => handleRemoveDetail(index)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <FormAction
                onSubmit={handleSave}
                onUpdate={handleSave}
                onCancel={callInitialize}
                mode={mode}
                disabled={formMasterList[0]?.rcvStatus !== 1}
                footer={true}
            />

            {/* Modals */}
            <InvoiceModal
                showInvModal={showInvModal}
                handleInvClose={handleInvClose}
                onRowSelectInv={onRowSelectInv}
                invDataList={invDataList}
                arId={formMasterList[0].arID}
            />
            <ArModal
                showArModal={showArModal}
                handleArClose={handleArClose}
                onRowSelectAr={onRowSelectAr}
                arDataList={arDataList}
            />
        </>
    );
}

export default Form;
